import {
  FileOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import React, { ReactElement } from "react";
import { Link } from "react-router-dom";

const MerchantSidebar = ({ merchantId }): ReactElement => {
  const pathname = window.location?.pathname;

  return (
    <>
      <div className="h-100 product-details-wrapper-content">
        <div className="aside-menu">
          <Menu
            defaultSelectedKeys={["0"]}
            // defaultOpenKeys={['sub1']}
            mode="inline"
          >
            <Menu.Item
              key="details"
              className={
                pathname.includes(`merchants/${merchantId}/details`)
                  ? "active"
                  : ""
              }
              icon={<ShopOutlined />}
            >
              <Link to={`/merchants/${merchantId}/details`}>
                Merchant Information
              </Link>
            </Menu.Item>

            <Menu.Item
              key="shops"
              icon={<ShopOutlined />}
              className={pathname.includes("/shops") ? "active" : ""}
            >
              <Link to={`/merchants/${merchantId}/shops`}>Shop Management</Link>
            </Menu.Item>

            {/* <Menu.Item
              key="orders"
              icon={<FileOutlined />}
              className={pathname.includes("/orders") ? "active" : ""}
            >
              <Link to={`/merchants/${merchantId}/orders`}>
                Order Management
              </Link>
            </Menu.Item> */}

            {/* <Menu.Item
              key="products"
              icon={<ShoppingCartOutlined />}
              className={pathname.includes("/products") ? "active" : ""}
            >
              <Link to={`/merchants/${merchantId}/products`}>
                Product Management
              </Link>
            </Menu.Item>*/}

            {/* <Menu.Item
              key="vendors"
              icon={<UserOutlined />}
              className={pathname.includes("/vendors") ? "active" : ""}
              disabled
            >
              <Link to={`/merchants/${merchantId}/vendors`}>Vendors</Link>
            </Menu.Item>

            <Menu.Item
              key="sales-man"
              icon={<UserOutlined />}
              className={pathname.includes("/sales-man") ? "active" : ""}
              disabled
            >
              <Link to={`/merchants/${merchantId}/sales-man`}>Sales Man</Link>
            </Menu.Item> */}
          </Menu>
        </div>
      </div>
    </>
  );
};

export default MerchantSidebar;
